module.exports = __webpack_public_path__ + "static/3-6da81ed7ecfa3697028954c4c66e0d34.jpg";